import FormGroup from '~/components/form/FormGroup';
import { FormHorizontal } from '~/components/form/layout';
import ZodFieldInput from '~/components/zod/ZodFieldInput';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import { useZodFormFieldSingle, useZodFormFieldSingleValue } from '~/components/zod/ZodForm';
import { useRef } from 'react';
import { PersonaType } from '~/tenants/common/TenantPersona';
import { MlmOrderType, MlmPropertyAccess } from '~/tenants/mlm/model/MlmOrder';
import ZodFieldHidden from '~/components/zod/ZodFieldHidden';
import ZodFieldTextarea from '~/components/zod/ZodFieldTextarea';

export default function MlmOrderForm({ persona }: { persona: PersonaType }) {
  const [_type, type] = useZodFormFieldSingle<MlmOrderType>('type');
  const access = useZodFormFieldSingleValue<MlmPropertyAccess>('access');
  const preselected = useRef(type !== undefined);

  return (
    <FormGroup>
      {preselected.current && <ZodFieldHidden name="type" />}
      {!preselected.current && (
        <FormHorizontal name="type" label="Type">
          <ZodFieldSelect
            name="type"
            options={[
              {
                label: 'Residential',
                value: MlmOrderType.RESIDENTIAL,
              },
              ...(persona === PersonaType.OFFICE
                ? [
                    {
                      label: 'Commercial',
                      value: MlmOrderType.COMMERCIAL,
                    },
                  ]
                : []),
            ]}
          />
        </FormHorizontal>
      )}
      <FormHorizontal name="sqft" label="Square Feet">
        <ZodFieldInput name="sqft" type="number" />
      </FormHorizontal>
      <FormHorizontal name="access" label="Access Type">
        <ZodFieldSelect
          name="access"
          options={[
            {
              label: 'Will Provider Later',
              value: MlmPropertyAccess.LATER,
            },
            {
              label: 'Homeowner Will Meet Photographer',
              value: MlmPropertyAccess.HOMEOWNER,
            },
            {
              label: 'Lockbox Code',
              value: MlmPropertyAccess.LOCKBOX,
            },
            {
              label: 'Sentri Code',
              value: MlmPropertyAccess.SENTRI,
            },
            {
              label: 'Agent Will Meet Photographer',
              value: MlmPropertyAccess.AGENT,
            },
          ]}
        />
      </FormHorizontal>
      {access && [MlmPropertyAccess.LOCKBOX, MlmPropertyAccess.SENTRI].includes(access) && (
        <FormHorizontal name="code" label="Access Code">
          <ZodFieldInput name="code" type="text" />
        </FormHorizontal>
      )}
      <FormHorizontal name="notes" label="Notes & Special Instructions">
        <ZodFieldTextarea name="notes" />
      </FormHorizontal>
    </FormGroup>
  );
}
